import { render, staticRenderFns } from "./sorotecageladeiras.vue?vue&type=template&id=f0ea4c14"
import script from "./sorotecageladeiras.vue?vue&type=script&lang=js"
export * from "./sorotecageladeiras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports